export const NCTR = {
  id: 1024,
  height: 6352327,
  data: {
    icon: "/imgs/icons/asset/nctr.svg",
  },
};
